<template>
  <!-- b-tooltip increases the width too much -->
  <!--<b-tooltip :label="name" position="is-bottom">-->
    <img class="image is-32x32" :src="imageSrc" :alt="name" :title="name"/>
  <!--</b-tooltip>-->
</template>

<script>
export default {
  name: "OptionHeader",
  props: ['imageSrc', 'name'],
}
</script>

<style scoped>

</style>